import React from "react";

export const MobilePropertyValue = ({ price }) => {
  return (
    <div className="irq-nav-wrapper">
      <div className="mobile-stat-wrapper">
        <span>$</span>
        <span className="bold">{parseFloat(price).toLocaleString()}</span>
      </div>
      Property Value
    </div>
  );
};
